// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4a2af79d","239":"03e22059","453":"ff745537","732":"5c98eda3"}[chunkId] + ".chunk.js";
};